/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface DashboardTrendBucketDTO { 
    bucket?: string;
    domande?: number;
    accettate?: number;
    rifiutate?: number;
    voucher_consumati?: number;
    incassi_mensa?: number;
}

